import cmsParser from 'Common/util/cmsParser';
import type { PageEntry, Entry } from 'contensis-delivery-api';

import type { Props } from './Content';
import { composerStrategy } from 'Common/util/cmsComposer';

export type PageData = {
    entry: PageEntry;
    sectionNavigation: Entry;
};

const datamap = (data: PageData): Props => {
    const { entry, sectionNavigation } = data;

    const navigation = {
        heading: 'Contents',
        links: sectionNavigation.items.map(item => ({
            href: item.sys.uri,
            label: item.heading
        }))
    };

    return {
        heading: entry.heading && entry.heading,
        pageNumber: entry.pageNumber,
        backgroundColor: cmsParser.getThemeColour(entry.backgroundColour.colourPicker),
        navigation: navigation,
        content: composerStrategy(entry.content.pageContent),
        tabNavigation: {
            tabs: entry.tabbedContent.map(tab => ({
                label: tab.tabName,
                ariaLabel: `Select for content on ${tab.tabName}`,
                id: tab.sys.id,
                content: composerStrategy(tab.pageContent)
            }))
        },
        pagination: {
            id: 'strategy-pagination',
            totalCount: sectionNavigation.items.length,
            pageSize: 1,
            initialPageIndex: entry.pageNumber - 1,
            fixedPageUrls: navigation.links.map(link => link.href)
        }
    };
};

export default datamap;
